/*
 * @Author:
 * @LastEditTime: 2024-09-25 17:17:24
 * @Description:
 */
import Vue from 'vue'

const EventBusHz = new Vue()
export default EventBusHz
